import {
  Button,
  Container,
  Image,
  SimpleGrid,
  Text,
  Title,
  createStyles,
  rem,
} from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import image from '../../assets/svg/notfound-page.svg';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: rem(80),
    paddingBottom: rem(80),
  },

  title: {
    fontWeight: 900,
    fontSize: rem(34),
    marginBottom: theme.spacing.md,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(32),
    },
  },

  control: {
    [theme.fn.smallerThan('sm')]: {
      width: '100%',
    },
  },

  mobileImage: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  desktopImage: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
}));

export function NotFound() {
  const navigate = useNavigate();
  const { classes } = useStyles();

  const handleSignUp = () => {
    navigate("/");
  }

  useEffect(() => {
    localStorage.clear();

    setTimeout(() => {
      handleSignUp();
    }, 5000)
  }, []);
  
  return (
    <Container className={classes.root}>
      <SimpleGrid spacing={80} cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1, spacing: 40 }]}>
        <Image src={image} className={classes.mobileImage} />
        <div>
          <Title className={classes.title}>Algo não está certo...</Title>
          <Text color="dimmed" size="lg">
            A página que você está tentando abrir não existe. Você pode ter digitado errado o endereço, ou o
            a página foi movida para outro URL. Se você acha que isso é um erro, entre em contato com o suporte.
          </Text>
          <br />
          <Text color="dimmed" size="lg">
            Em <b>5</b> segundos você será redirecionado para a tela de login.
          </Text>
          <Button variant="outline" size="md" mt="xl" onClick={handleSignUp} className={classes.control}>
            Volte para a página inicial
          </Button>
        </div>
        <Image src={image} className={classes.desktopImage} />
      </SimpleGrid>
    </Container>
  );
}